import React from 'react';

/**
 * EduManage logo — uses the RT Edu Services brand marks shipped in /public.
 *
 * `variant="mark"`   — compact circular R|T monogram (favicon_simple.svg),
 *                      crisp at small sizes. Used in sidebar / header.
 * `variant="emblem"` — full RT Edu Services woven medallion
 *                      (rt_edu_services_logo.svg). Used on login hero.
 */
const Logo = ({
  size = 36,
  showWordmark = false,
  wordmarkSize = 17,
  wordmark = 'EduManage',
  variant = 'mark'
}) => {
  const src =
    variant === 'emblem'
      ? '/rt_edu_services_logo.svg'
      : '/favicon_simple.svg';

  const tileSize = variant === 'emblem' ? Math.max(size, 52) : size;

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
      <img
        src={src}
        alt={wordmark}
        width={tileSize}
        height={tileSize}
        style={{ display: 'block', flexShrink: 0 }}
      />
      {showWordmark && (
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15 }}>
          <span style={{
            fontWeight: 700,
            fontSize: wordmarkSize,
            letterSpacing: '-0.3px',
            color: 'var(--ink)'
          }}>
            {wordmark}
          </span>
          {variant === 'emblem' && (
            <span style={{
              fontSize: 10,
              color: 'var(--ink-3, #6b5a45)',
              letterSpacing: '1.4px',
              textTransform: 'uppercase',
              marginTop: 2
            }}>
              by RT Edu Services
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;
